import React from 'react';
import { Accordion } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'; // Ensure Bootstrap CSS is imported
import '../../styles/project.css'; // Import specific CSS for styling
import '../../styles/Fonts.css'; // Import font styling if needed

const faqData = [
  {
    question: 'What types of project cargo do you handle?',
    answer: (
      <p className='poppins-regular text-start'>
        We handle all types of project cargo including oversized equipment, heavy machinery, 
        construction materials, and specialized event logistics. Our services are customized for each project's unique requirements.
      </p>
    ),
  },
  {
    question: 'Do you provide event logistics for special occasions?',
    answer: (
      <p className='poppins-regular text-start'>
        Yes, we specialize in event logistics for world tours, special events, exhibitions, and entertainment productions. 
        We coordinate all transportation and handling aspects for seamless event execution.
      </p>
    ),
  },
  {
    question: 'How do you ensure safe transport of oversized cargo?',
    answer: (
      <p className='poppins-regular text-start'>
        We use specialized equipment, conduct detailed route surveys, obtain necessary permits, 
        and provide escort services when required. Our expert team ensures all safety protocols are followed.
      </p>
    ),
  },
  {
    question: 'What permits and documentation do you handle?',
    answer: (
      <p className='poppins-regular text-start'>
        We manage all necessary permits including overweight/oversized permits, route clearances, 
        and regulatory compliance documentation. Our team handles the entire permit process from start to finish.
      </p>
    ),
  },
];

const ProjectFAQ = () => {
  return (
    <section id="faq" className="project-faq-section">
      <div className="container">
        <div className="section-header text-center">
          <div className="section-badge">HAVE QUESTIONS?</div>
          <h2 className="section-title">Frequently Asked Questions</h2>
          <p className="section-description">
            Get answers to common questions about our project cargo services and logistics solutions.
          </p>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-8">
            <Accordion>
              {faqData.map((faq, index) => (
                <Accordion.Item eventKey={index.toString()} key={index}>
                  <Accordion.Header>
                    <h5 className="mb-0">{faq.question}</h5>
                  </Accordion.Header>
                  <Accordion.Body>
                    {faq.answer}
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectFAQ;
